module.exports = __webpack_public_path__ + "static/media/mandy-win.50ccddfe.png";